import React, { ReactElement, ComponentType, FC } from 'react';

import {
    SafetyCertificateOutlined,
    DownloadOutlined,
    DeleteOutlined,
    FileExcelOutlined,
    AuditOutlined,
    SendOutlined,
    ShareAltOutlined,
    SettingOutlined,
    LinkOutlined,
} from '@ant-design/icons';

import { IS_BRANDED, NEUTRAL_LOGO_URL } from '@/config/branding';
import GoogleSvg from './GoogleSvg';
import Office365Svg from './Office365Svg';
import ViewerSvg from './ViewerSvg';
import { OpenOptions } from '../../../config/openOptions';
import { FileOptionType } from '../../../types/types';

export type FileActionType = FileOptionType
| OpenOptions
| 'share'
| 'new_share'
| 'manage_access'
| 'copy_link';

export interface FileMenuItem {
    title: string;
    icon?: ReactElement;
    component?: ComponentType;
}

// ViewerSvg is the SpecterX logo, so unbranded builds fall back to the same
// neutral mark that replaces the favicon in the browser tab.
const NeutralViewerIcon: FC = () => <img src={NEUTRAL_LOGO_URL} alt="" width={15} height={15} />;

const viewerIcon = IS_BRANDED ? ViewerSvg : NeutralViewerIcon;

export const items: Partial<Record<FileActionType, FileMenuItem>> = {
    set_policy: {
        title: 'securitySettings',
        icon: <SafetyCertificateOutlined />,
    },
    set_file_policy: {
        title: 'setFilePolicy',
        icon: <SafetyCertificateOutlined />,
    },
    download: {
        title: 'download',
        icon: <DownloadOutlined />,
    },
    delete: {
        title: 'delete',
        icon: <DeleteOutlined />,
    },
    delete_file: {
        title: 'deleteFile',
        icon: <DeleteOutlined />,
    },
    webdav: {
        title: 'officeForDesktop',
        component: viewerIcon,
    },
    googledrive: {
        title: 'googleDocksViewingOnly',
        component: GoogleSvg,
    },
    office365: {
        title: 'office365',
        component: Office365Svg,
    },
    viewer: {
        title: 'viewer',
        component: viewerIcon,
    },
    revoke: {
        title: 'revoke',
        icon: <FileExcelOutlined />,
    },
    audits: {
        title: 'audits',
        icon: <AuditOutlined />,
    },
    new_share: {
        title: 'newShare',
        icon: <SendOutlined />,
    },
    share: {
        title: 'share',
        icon: <ShareAltOutlined />,
    },
    manage_access: {
        title: 'permissionsAndPolicy',
        icon: <SettingOutlined />,
    },
    copy_link: {
        title: 'copyLink',
        icon: <LinkOutlined />,
    },
};
